/**
 * Formats a personal identity number for display.
 * Accepts `YYYYMMDDXXXX` and `YYYYMMDD-XXXX`; returns "-" when empty/invalid.
 */
export const formatPersonalIdentityNumber = (
  personalIdentityNumber: string | null,
): string => {
  const normalizedValue = (personalIdentityNumber ?? "").trim();
  if (normalizedValue.length === 0) return "-";
  if (/^\d{8}-\d{4}$/.test(normalizedValue)) return normalizedValue;
  if (/^\d{12}$/.test(normalizedValue)) {
    return `${normalizedValue.slice(0, 8)}-${normalizedValue.slice(8, 12)}`;
  }
  return "-";
};
